import React from "react";
import { Button } from "@mui/material";
import { tokens } from "./tokens";

const defaultSx = {
  display: "flex",
  padding: "8px 22px",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "var(--medium, 8px)",
  border: "1px solid var(--primary-_states-outlinedBorder, rgba(83, 109, 236, 0.50))",
  fontFamily: tokens.fontFamily.primary,
  fontWeight: 600,
  fontSize: "0.875rem",
  textTransform: "none",
  color: "var(--primary-main, #536DEC)",
  backgroundColor: "transparent",
  "&:hover": {
    borderColor: "var(--primary-_states-outlinedBorder, rgba(83, 109, 236, 0.50))",
    backgroundColor: "rgba(83, 109, 236, 0.04)",
  },
  "&.Mui-disabled": {
    borderColor: "rgba(0,0,0,0.12)",
    color: "rgba(0,0,0,0.38)",
  },
};

/**
 * Secondary (outlined) button for cancel or secondary actions.
 * Accepts all MUI Button props; sx is merged with default styles.
 */
const SecondaryButton = ({ sx, size = "medium", ...rest }) => {
  const sizeSx =
    size === "small"
      ? { height: 36, padding: "6px 16px", fontSize: "0.875rem" }
      : {};
  return <Button variant="outlined" size={size} sx={{ ...defaultSx, ...sizeSx, ...sx }} {...rest} />;
};

export default SecondaryButton;